import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * CD type-ramp tokens live under `text-*` (e.g. text-header-01) and must be
 * registered as font-size so they don't conflict with text color utilities
 * (text-white, text-primary, …) inside twMerge / cn().
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display-01',
            'display-02',
            'display-03',
            'display-04',
            'header-01',
            'header-02',
            'header-03',
            'body-default',
            'body-bold',
            'body-sm',
            'body-sm-bold',
            'cta',
            'cta-sm',
            'label-lg-bold',
            'label-lg',
            'label-bold',
            'label',
            'label-sm-bold',
            'label-sm',
            'smallprint',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
